import router from "@/router";
import store from "@/store";
import { DEFAULT_SCOPES } from "./scopes";
const axios = require("axios");

// TrainPlanet API instance.
const api = axios.create({
  baseURL: process.env.VUE_APP_TRAINPLANET_API_URL_BASE,
  timeout: 3600000, // 1 hour
});

let routerReady = null;
const whenRouterReady = () => {
  if (!routerReady) {
    // Resolve on failure too, a broken navigation must not block every request.
    routerReady = new Promise((resolve) => router.onReady(resolve, resolve));
  }

  return routerReady;
};

const resolveScopes = () => {
  const matched = router.currentRoute.matched || [];

  for (let i = matched.length - 1; i >= 0; i -= 1) {
    const { scopes } = matched[i].meta || {};
    if (scopes && scopes.length) return scopes;
  }

  return DEFAULT_SCOPES;
};

/**
 *
 *
 * Request middleware.
 * Get and set credentials before each request.
 *
 *
 */

api.interceptors.request.use(async (request) => {
  const middleware = request;
  await whenRouterReady();
  const token = await store.dispatch("auth/acquireToken", resolveScopes());
  /* eslint-disable dot-notation */
  middleware.headers["Authorization"] = `Bearer ${token}`;
  middleware.headers["Content-Type"] = "application/json";

  return middleware;
});

export default api;

